// extracted by mini-css-extract-plugin
module.exports = {"root":"drawer-header-title_root__rwRyf"};